<script setup>
import { useStore } from "vuex";
import { defineProps, defineEmits, ref, watch, computed } from "vue";

const store = useStore();

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  accept: {
    type: String,
    default: ".jpg,.png,.jpeg",
  },
  maxSize: {
    type: Number,
    default: null,
  },
});

const fileInput = ref(null);
const _error = ref(null);
const success = computed(() => store.getters["utilities/getSuccessStatus"]);

const uploadFile = () => {
  fileInput.value.click();
};

const handleFileSelect = (e) => {
  const file = e.target.files[0];

  if (file && props.maxSize && file.size > props.maxSize) {
    _error.value =
      "File size exceeds the maximum limit of " +
      props.maxSize / 1024 / 1024 +
      " MB";
    return;
  } else {
    _error.value = null;
  }
  emit("update:modelValue", {
    file: file,
    filename: file?.name,
  });
};

watch(success, (value) => {
  if (value) fileInput.value.value = null;
});
</script>

<template>
  <input
    type="file"
    :name="props.label"
    style="display: none"
    ref="fileInput"
    :accept="accept"
    @change="handleFileSelect"
  />
  <div class="input-group input-group-md col-md-8">
    <input
      :value="props.modelValue.filename"
      type="text"
      class="form-control"
      placeholder="No file chosen"
      disabled
    />
    <span class="input-group-btn">
      <button
        @click="uploadFile"
        type="button"
        class="btn btn-info btn-flat tm-btn-green"
      >
        {{ props.label }}
      </button>
    </span>
  </div>
  <div class="text-danger ml-2" v-if="_error">
    <font-awesome-icon icon="exclamation-triangle" />
    {{ _error }}
  </div>
</template>
